let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8a9Nc")).then(() => parcelRequire('6er0q'));